import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import avo from 'analytics/avo';
import useIsTouchDevice from 'hooks/useIsTouchDevice';
import MaterialThumbnailUI from './MaterialThumbnailUI';
import MaterialThumbnailPlaceholder from './MaterialThumbnailPlaceholder';
const DEFAULT_FABRIC_FAV_PROPS = {};
const MaterialThumbnail = t0 => {
  const $ = _c(56);
  const {
    color,
    customToggleFlyOut: t1,
    customToggleFlyOutData: t2,
    fabricFavProps: t3,
    fullHeightThumbnail: t4,
    image,
    isDisabled: t5,
    isFavMaterial,
    isInFlashSale: t6,
    isRound: t7,
    isSelected,
    label,
    loading,
    materialApplicableForProduct: t8,
    materialId,
    onClick,
    onHover,
    show: t9,
    toggleFlyOut,
    upholsteryOptionId,
    variant
  } = t0;
  const customToggleFlyOut = t1 === undefined ? false : t1;
  const customToggleFlyOutData = t2 === undefined ? null : t2;
  const fabricFavProps = t3 === undefined ? DEFAULT_FABRIC_FAV_PROPS : t3;
  const fullHeightThumbnail = t4 === undefined ? false : t4;
  const isDisabled = t5 === undefined ? false : t5;
  const isInFlashSale = t6 === undefined ? false : t6;
  const isRound = t7 === undefined ? false : t7;
  const materialApplicableForProduct = t8 === undefined ? true : t8;
  const show = t9 === undefined ? true : t9;
  const {
    actions: t10,
    data: t11
  } = fabricFavProps;
  let t12;
  if ($[0] !== t10) {
    t12 = t10 === undefined ? {} : t10;
    $[0] = t10;
    $[1] = t12;
  } else {
    t12 = $[1];
  }
  const {
    setOptionAsFav,
    removeOptionAsFav
  } = t12;
  let t13;
  if ($[2] !== t11) {
    t13 = t11 === undefined ? {} : t11;
    $[2] = t11;
    $[3] = t13;
  } else {
    t13 = $[3];
  }
  const {
    favProductData
  } = t13;
  let t14;
  if ($[4] !== color || $[5] !== favProductData || $[6] !== label || $[7] !== materialId || $[8] !== setOptionAsFav) {
    t14 = setOptionAsFav ? {
      fabricId: materialId,
      fabricName: label,
      fabricColor: color,
      location: "PDP",
      ...favProductData
    } : {};
    $[4] = color;
    $[5] = favProductData;
    $[6] = label;
    $[7] = materialId;
    $[8] = setOptionAsFav;
    $[9] = t14;
  } else {
    t14 = $[9];
  }
  const favParams = t14;
  const isTouchDevice = useIsTouchDevice();
  const lastTapRef = useRef(null);
  const DOUBLE_PRESS_DELAY = 300;
  let t15;
  if ($[10] !== favParams || $[11] !== isFavMaterial || $[12] !== isSelected || $[13] !== isTouchDevice || $[14] !== materialId || $[15] !== onClick || $[16] !== removeOptionAsFav || $[17] !== setOptionAsFav || $[18] !== upholsteryOptionId) {
    t15 = evt => {
      evt.preventDefault();
      evt.stopPropagation();
      if (!isSelected) {
        if (typeof onClick === "function") {
          onClick(upholsteryOptionId, materialId, "customizer");
        }
      } else {
        if (!isTouchDevice || !setOptionAsFav || !removeOptionAsFav) {
          return;
        }
        if (lastTapRef?.current && Date.now() - lastTapRef.current < 300) {
          if (isFavMaterial) {
            removeOptionAsFav(materialId);
            avo.fabricUnfavorited(favParams);
          } else {
            if (!isFavMaterial) {
              setOptionAsFav(materialId);
              avo.fabricFavorited(favParams);
            }
          }
          lastTapRef.current = null;
        } else {
          lastTapRef.current = Date.now();
        }
      }
    };
    $[10] = favParams;
    $[11] = isFavMaterial;
    $[12] = isSelected;
    $[13] = isTouchDevice;
    $[14] = materialId;
    $[15] = onClick;
    $[16] = removeOptionAsFav;
    $[17] = setOptionAsFav;
    $[18] = upholsteryOptionId;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  const onClickHandler = t15;
  let t16;
  if ($[20] !== favParams || $[21] !== isFavMaterial || $[22] !== isSelected || $[23] !== isTouchDevice || $[24] !== materialApplicableForProduct || $[25] !== materialId || $[26] !== removeOptionAsFav || $[27] !== setOptionAsFav || $[28] !== toggleFlyOut) {
    t16 = evt_0 => {
      evt_0.preventDefault();
      evt_0.stopPropagation();
      if (isTouchDevice || !setOptionAsFav || !removeOptionAsFav) {
        return;
      }
      if (isSelected || !materialApplicableForProduct) {
        if (isFavMaterial) {
          if (typeof toggleFlyOut === "function") {
            toggleFlyOut(false, materialId);
          }
          removeOptionAsFav(materialId);
          avo.fabricUnfavorited(favParams);
        } else {
          setOptionAsFav(materialId);
          avo.fabricFavorited(favParams);
        }
      }
    };
    $[20] = favParams;
    $[21] = isFavMaterial;
    $[22] = isSelected;
    $[23] = isTouchDevice;
    $[24] = materialApplicableForProduct;
    $[25] = materialId;
    $[26] = removeOptionAsFav;
    $[27] = setOptionAsFav;
    $[28] = toggleFlyOut;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  const onDblClick = t16;
  let t17;
  if ($[30] !== materialId || $[31] !== onHover || $[32] !== upholsteryOptionId) {
    t17 = () => onHover(upholsteryOptionId, materialId);
    $[30] = materialId;
    $[31] = onHover;
    $[32] = upholsteryOptionId;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  const onHoverHandler = t17;
  if (loading) {
    let t18;
    if ($[34] !== fullHeightThumbnail || $[35] !== variant) {
      t18 = <MaterialThumbnailPlaceholder fullHeightThumbnail={fullHeightThumbnail} variant={variant} />;
      $[34] = fullHeightThumbnail;
      $[35] = variant;
      $[36] = t18;
    } else {
      t18 = $[36];
    }
    return t18;
  }
  const t18 = materialApplicableForProduct ? onClickHandler : undefined;
  const t19 = onHover ? onHoverHandler : undefined;
  let t20;
  if ($[37] !== customToggleFlyOut || $[38] !== customToggleFlyOutData || $[39] !== fullHeightThumbnail || $[40] !== image || $[41] !== isDisabled || $[42] !== isFavMaterial || $[43] !== isInFlashSale || $[44] !== isRound || $[45] !== isSelected || $[46] !== label || $[47] !== materialApplicableForProduct || $[48] !== materialId || $[49] !== onDblClick || $[50] !== show || $[51] !== t18 || $[52] !== t19 || $[53] !== toggleFlyOut || $[54] !== variant) {
    t20 = <MaterialThumbnailUI customToggleFlyOut={customToggleFlyOut} customToggleFlyOutData={customToggleFlyOutData} fullHeightThumbnail={fullHeightThumbnail} image={image} isDisabled={isDisabled} isFavMaterial={isFavMaterial} isInFlashSale={isInFlashSale} isRound={isRound} isSelected={isSelected} label={label} materialApplicableForProduct={materialApplicableForProduct} materialId={materialId} onClick={t18} onDblClick={onDblClick} onHover={t19} show={show} toggleFlyOut={toggleFlyOut} variant={variant} />;
    $[37] = customToggleFlyOut;
    $[38] = customToggleFlyOutData;
    $[39] = fullHeightThumbnail;
    $[40] = image;
    $[41] = isDisabled;
    $[42] = isFavMaterial;
    $[43] = isInFlashSale;
    $[44] = isRound;
    $[45] = isSelected;
    $[46] = label;
    $[47] = materialApplicableForProduct;
    $[48] = materialId;
    $[49] = onDblClick;
    $[50] = show;
    $[51] = t18;
    $[52] = t19;
    $[53] = toggleFlyOut;
    $[54] = variant;
    $[55] = t20;
  } else {
    t20 = $[55];
  }
  return t20;
};
MaterialThumbnail.propTypes = {
  color: PropTypes.string,
  customToggleFlyOut: PropTypes.bool,
  customToggleFlyOutData: PropTypes.object,
  fabricFavProps: PropTypes.object,
  fullHeightThumbnail: PropTypes.bool,
  image: PropTypes.string,
  isDisabled: PropTypes.bool,
  isFavMaterial: PropTypes.bool,
  isInFlashSale: PropTypes.bool,
  isRound: PropTypes.bool,
  isSelected: PropTypes.bool,
  label: PropTypes.string,
  loading: PropTypes.bool,
  materialApplicableForProduct: PropTypes.bool,
  materialId: PropTypes.number,
  onClick: PropTypes.func,
  onHover: PropTypes.func,
  show: PropTypes.bool,
  toggleFlyOut: PropTypes.func,
  upholsteryOptionId: PropTypes.number,
  variant: PropTypes.oneOf(['PDPCustomerPhotosReviewsModal', 'PDPShownInUI', 'PDPShownInUI--grey-background'])
};
export default MaterialThumbnail;